import type { DateTimeFormatFuncProps } from './types';

export const formatDate = ({ locale, date }: DateTimeFormatFuncProps) => {
  const withYear = date.getFullYear() !== new Date().getFullYear();
  return new Intl.DateTimeFormat(locale, {
    month: 'long',
    day: 'numeric',
    year: withYear ? 'numeric' : undefined
  }).format(date);
};
